import QRCodeVue from '@/views/sic/qr-code/qr-code.vue';

const basePath = '/sic/qr-code';
const role = 'sic'; // 角色身份

export const SIC_QR_CODE_INDEX = 'sic-qr-code';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: QRCodeVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_QR_CODE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/qr-code/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
